<script setup lang="ts">
useHead({
  script: [
    // meta pixel code
    {
      innerHTML:
        "!function(f,b,e,v,n,t,s){ if(f.fbq)return;n=f.fbq=function(){n.callMethod? n.callMethod.apply(n,arguments):n.queue.push(arguments)}; if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0'; n.queue=[];t=b.createElement(e);t.async=!0; t.src=v;s=b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t,s)}(window, document,'script', 'https://connect.facebook.net/en_US/fbevents.js'); fbq('init', '807328172250818'); fbq('track', 'PageView');",
      tagPosition: 'head',
    },
    // google tag manager
    {
      innerHTML:
        "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src= 'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f); })(window,document,'script','dataLayer','GTM-5G2Q92FJ');",
      tagPosition: 'head',
    },
    // linkedin insight tag
    {
      innerHTML:
        '_linkedin_partner_id = "8074114"; window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || []; window._linkedin_data_partner_ids.push(_linkedin_partner_id); (function(l) { if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])}; window.lintrk.q=[]} var s = document.getElementsByTagName("script")[0]; var b = document.createElement("script"); b.type = "text/javascript";b.async = true; b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js"; s.parentNode.insertBefore(b, s);})(window.lintrk);',
      tagPosition: 'head',
    },
  ],
  noscript: [
    // meta pixel code
    {
      innerHTML:
        '<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=807328172250818&ev=PageView&noscript=1" />',
      tagPosition: 'head',
    },
    // google tag manager
    {
      innerHTML:
        '<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-5G2Q92FJ" height="0" width="0" style="display:none;visibility:hidden"></iframe>',
      tagPosition: 'bodyOpen',
    },
    // linkedin insight tag
    {
      innerHTML:
        '<img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=8074114&fmt=gif" />',
      tagPosition: 'bodyClose',
    },
  ],
});
</script>
